export enum InspectionTypes {
    Presentation = 1,
    Visit = 2,
    Response = 3
}
